import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IGetMachinesParams, getMachines } from '../../../../api/machine/queries/getMachines';
import { IMachineListMachine } from '../../../../interfaces/Dictionary.interfaces';

interface IUseGetMachinesQueryParams extends IGetMachinesParams {
  options?: UseQueryOptions<IMachineListMachine[], AxiosError>;
}

export const useGetMachinesQuery = ({ searchParam, options }: IUseGetMachinesQueryParams) => {
  return useQuery<IMachineListMachine[], AxiosError>(
    ['machines', searchParam.brandId, searchParam.fields, searchParam.searchTerm],
    () => getMachines({ searchParam }),
    options,
  );
};
